const SLACK_URL_ERROR =
	"https://hooks.slack.com/triggers/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";

const SLACK_URL_SUCCESS =
	"https://hooks.slack.com/triggers/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";

const env = import.meta.env.VITE_FRONTEND_URL;

export function reportErrorToSlack(
	errorType: string,
	event: unknown,
	error: Error,
) {
	if (env.includes("localhost") || env.includes("127.0.0.1")) return;

	const body = JSON.stringify({
		env,
		errorType,
		error: (JSON.stringify(error) === "{}"
			? error.toString()
			: JSON.stringify(error)
		).slice(0, 500),
		event: JSON.stringify(event, null, "\t").slice(0, 500),
	});

	// avoid reporting expired token redirection
	if (
		body.includes("400 Request Header Or Cookie Too Large") ||
		body.includes("removeChild") ||
		body.includes("insertBefore") ||
		body.includes("TypeError: Failed to fetch") ||
		body.includes("307") ||
		body.includes("openid-connect/logout") ||
		body.includes("TypeError: NetworkError when attempting to fetch resource.")
	)
		return;

	return fetch(SLACK_URL_ERROR, {
		method: "POST",
		body,
	});
}

export async function reportSuccessToSlack(
	successType: string,
	event: unknown,
) {
	if (env.includes("localhost") || env.includes("127.0.0.1")) return;

	const body = JSON.stringify({
		env,
		successType,
		event: JSON.stringify(event),
	});

	return fetch(SLACK_URL_SUCCESS, {
		method: "POST",
		body,
	});
}
